// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const MedicalVisitIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M22.23 9.55c-.15-2.6-2.31-4.66-4.94-4.66H6.71c-2.63 0-4.79 2.06-4.94 4.66l-.01.3v7.7c0 2.72 2.22 4.95 4.95 4.95h10.58c2.73 0 4.95-2.23 4.95-4.95z"
        opacity=".5"
      />
      <path d="M9.13 4.43c0-.72.58-1.3 1.3-1.3h3.15c.71 0 1.29.58 1.29 1.3v.46h1.63v-.46c0-1.61-1.3-2.93-2.92-2.93h-3.15c-1.63 0-2.94 1.32-2.94 2.93v.46h1.64zm5.02 11.41h-1.33v-1.33c0-.45-.37-.82-.82-.82s-.82.37-.82.82v1.33H9.86c-.46 0-.82.37-.82.82s.36.82.82.82h1.32v1.32c0 .45.37.82.82.82s.82-.37.82-.82v-1.32h1.33c.45 0 .81-.37.81-.82s-.36-.82-.81-.82m8.08-6.29H1.77l-.01.3v1.34h20.48z" />
    </g>
  </SvgIcon>
);

export default MedicalVisitIcon;
